import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-769ee70b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "groups" }
const _hoisted_2 = { class: "title bold" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "border" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (!_ctx.hideViewAll)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.isViewAll || _ctx.noHideAll)
            ? (_openBlock(), _createElementBlock("h5", {
                key: 0,
                class: "title",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.viewAll && _ctx.viewAll(...args)))
              }, "View all"))
            : (_openBlock(), _createElementBlock("h5", {
                key: 1,
                class: "title",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideAll && _ctx.hideAll(...args)))
              }, "Hide all"))
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}